import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Muncy Lodge No. 299 F & A.M.</h3>
          <p>Building Better Men for Our Community</p>
          <p className="footer-address">
            28 Brummer Pond Rd<br />
            Muncy, PA 17756
          </p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="https://pagrandlodge.org" target="_blank" rel="noopener noreferrer">PA Grand Lodge</a></li>
            <li><a href="https://masoniccharitiespa.org/" target="_blank" rel="noopener noreferrer">PA Masonic Charities</a></li>
            <li><a href="https://portal.pamasons.org/" target="_blank" rel="noopener noreferrer">Grand View Login</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Connect With Us</h3>
          <div className="social-links">
            <a 
              href="https://www.facebook.com/muncylodge299" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="social-icon"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a 
              href="mailto:muncylodge299@gmail.com" 
              aria-label="Email"
              className="social-icon"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Muncy Lodge No. 299 F & A.M. All rights reserved.</p>
        <p className="footer-disclaimer">Muncy Lodge No. 299 is a proud member of the <a href="https://pagrandlodge.org" target="_blank" rel="noopener noreferrer">Grand Lodge of Pennsylvania F & A.M.</a></p>
      </div>
    </footer>
  );
}

export default Footer;
